import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const PackageImage = ({ packageId, imageName, size = "w-32 h-32" }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      try {
        const response = await axios.get(`${API}/settings/packages/${packageId}/image`, {
          responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        setImageUrl(url);
      } catch (err) {
        console.error('Failed to load package image:', packageId, err);
        setError(true);
      }
    };
    
    if (packageId) {
      loadImage();
    }
    
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [packageId, imageUrl]);

  if (error || !imageUrl) {
    return null;
  }

  return (
    <img 
      src={imageUrl}
      alt={imageName}
      className={size}
      style={{ display: 'block' }}
    />
  );
};

export default PackageImage;
